
                  export function injectStyle(text) {
                    if (typeof document !== 'undefined') {
                      var style = document.createElement('style')
                      var node = document.createTextNode(text)
                      style.appendChild(node)
                      document.head.appendChild(style)
                    }
                  }
                